import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SurveysOpinionTaskService } from '../../../services/surveys-opinion-task.service';
import { QuestionTypeCodeEnum } from '../../../models/surveys-tasks/QuestionsList';
import { SurveyResponseDetails } from '../../../models/surveys-tasks/SurveyResponseDetails';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { SwalService } from 'projects/shared/src/services/swal.service';

@Component({
  selector: 'app-surveys-tasks-response-details',
  standalone: false,
  templateUrl: './surveys-tasks-response-details.component.html'
})
export class SurveysTasksResponseDetailsComponent implements OnInit, OnDestroy {
  @Input() selectedRecordId!: number;
  @Input() taskId!: number;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();
  subscriptions: Subscription[] = [];
  details: SurveyResponseDetails = new SurveyResponseDetails();
  QuestionTypeCodeEnum = QuestionTypeCodeEnum

  constructor(
    private service: SurveysOpinionTaskService,
    private translate: TranslateService,
    private swalService: SwalService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true;
    this.service.getSurveyResponseDetails(this.selectedRecordId).subscribe((data: any) => {
      this.dataLoading = false;
      this.details = data;
    })
  }

  deleteRecord() {
    Swal.fire({
      title: this.translate.instant('surveyTasks.confirmDeleteResponse'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.service.deleteResponse(this.details.responseId).subscribe(
          (data: any) => {
            if (data) {
              this.dataLoading = true;
              Swal.fire({
                title: this.translate.instant('surveyTasks.responseDeletedSuccessfully'),
                text: '',
                imageUrl: './assets/images/icons/success.svg',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.close.emit()
              this.service.refreshDetails.next(true);
            }
          },
          (error: any) => {
            this.dataLoading = false;
            this.handleErrors(error.detail)
          });
      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
